
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireinpimprichichwad() {



    const cardData =
    {
        keyword: 'Bus Hire in Pimpri Chinchwad',
        heading: 'Amruta Travels: Bus Hire in Pimpri Chinchwad',
        headingDescription: 'Amruta Travels offers Bus Hire in Pimpri Chinchwad, providing reliable and comfortable transportation solutions for various occasions. Whether you are organizing a corporate event, school trip, family function, or group tour, our well-maintained buses ensure a smooth and enjoyable journey. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your travel in and around Pimpri Chinchwad simple and stress-free. Book your bus with Amruta Travels and experience a journey of comfort and convenience!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



  "services": [
    {
      "name": "Bus Hire in Pimpri Chinchwad for Outstation",
      "description": "Amruta Travels offers reliable bus rentals in Pimpri Chinchwad for outstation trips. Whether you are planning a weekend getaway, a pilgrimage, or a business trip, our fleet of buses ensures a comfortable and hassle-free journey to your destination."
    },
    {
      "name": "Bus Rental in Pimpri Chinchwad",
      "description": "Looking for a bus rental in Pimpri Chinchwad? Choose from our wide range of buses for group travel. Our fleet includes options from mini buses to large 50-seater buses, all equipped with comfortable seating and experienced drivers for a safe and smooth journey."
    },
    {
      "name": "Bus on Rent Near Me Pimpri Chinchwad",
      "description": "If you are searching for a bus on rent near you in Pimpri Chinchwad, Amruta Travels has got you covered. Our buses are perfect for local trips, family outings, and corporate events, offering flexibility in booking and various seating capacities."
    },
    {
      "name": "Urbania Bus on Rent in Pimpri Chinchwad",
      "description": "Rent the luxurious Force Urbania bus for your next trip from Pimpri Chinchwad. Ideal for small groups or corporate events, this vehicle offers comfortable seating, modern amenities, and a smooth, stylish ride for any occasion."
    },
    {
      "name": "14 17 25 32 Seater on Rent in Pimpri Chinchwad",
      "description": "Amruta Travels offers a variety of buses for rent in Pimpri Chinchwad, including 14-seater, 17-seater, 25-seater, and 32-seater options. Whether it’s a family trip, a school outing, or a group event, we provide comfortable and affordable transport solutions."
    },
    {
      "name": "35 40 45 50 Seater on Rent in Pimpri Chinchwad",
      "description": "For larger groups, Amruta Travels offers 35, 40, 45, and 50-seater buses on rent in Pimpri Chinchwad. These spacious buses are perfect for corporate outings, school picnics, or any large group travel, ensuring comfort and convenience on your journey."
    },
    {
      "name": "AC Tempo Traveller on Rent in Pimpri Chinchwad",
      "description": "Hire a premium AC Tempo Traveller for your group travel in Pimpri Chinchwad. Our tempo travellers are equipped with modern amenities, spacious seating, and air conditioning to provide a comfortable and pleasant ride for small to medium-sized groups."
    },
    {
      "name": "Bus on Rent in Pimpri Chinchwad",
      "description": "Amruta Travels provides convenient bus rental services in Pimpri Chinchwad for various events, including picnics, corporate trips, and family outings. Choose from our fleet of well-maintained buses to ensure a safe and comfortable journey."
    },
    {
      "name": "Mini Bus on Rent in Chinchwad",
      "description": "For smaller groups, Amruta Travels offers mini bus rentals in Chinchwad. Perfect for family trips, school excursions, or corporate gatherings, our mini buses offer comfortable seating and affordable rates."
    },
    {
      "name": "Bus Hire for School Picnic in Pimpri Chinchwad",
      "description": "Plan a safe and enjoyable school picnic with our bus hire service in Pimpri Chinchwad. Our buses are equipped with safety features and comfortable seating, ensuring your students have a pleasant journey to their picnic destination."
    },
    {
      "name": "Corporate Bus Hire in Pimpri Chinchwad",
      "description": "Amruta Travels offers reliable corporate bus hire services in Pimpri Chinchwad for team outings, office events, or business trips. Our buses are perfect for transporting employees in comfort, with professional drivers ensuring a smooth and timely journey."
    },
    {
      "name": "Bus Hire in Pimpri Chinchwad for Wedding Function",
      "description": "Make your wedding transportation seamless with Amruta Travels' bus hire services in Pimpri Chinchwad. Our buses are ideal for transporting guests to and from wedding venues, offering comfort, convenience, and punctuality for your special day."
    },
    {
      "name": "Bus Hire for Events Party in Pimpri Chinchwad",
      "description": "For events or parties in Pimpri Chinchwad, Amruta Travels offers bus rentals to accommodate large groups. Whether it's a concert, a celebration, or a corporate event, our buses provide a comfortable and stylish mode of transport."
    }
  ],
  "tableData": [
    ["Bus Hire in Pimpri Chinchwad for Outstation", "Bus Rental in Pimpri Chinchwad"],
    ["Bus on Rent Near Me Pimpri Chinchwad", "Urbania Bus on Rent in Pimpri Chinchwad"],
    ["14 17 25 32 Seater on Rent in Pimpri Chinchwad", "35 40 45 50 Seater on Rent in Pimpri Chinchwad"],
    ["AC Tempo Traveller on Rent in Pimpri Chinchwad", "Bus on Rent in Pimpri Chinchwad"],
    ["Mini Bus on Rent in Chinchwad", "Bus Hire for School Picnic in Pimpri Chinchwad"],
    ["Corporate Bus Hire in Pimpri Chinchwad", "Bus Hire in Pimpri Chinchwad for Wedding Function"],
    ["Bus Hire for Events Party in Pimpri Chinchwad", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Bus Hire Service in Pimpri Chinchwad",
    "WhyChoosedescription": "Amruta Travels offers dependable and professional Bus Hire in Pimpri Chinchwad, catering to a wide range of travel needs—from family functions and corporate events to school trips and local tours. Whether you're planning a one-day outing or a multi-day tour, our well-maintained fleet is available right near you for a smooth and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Ideal for Local and Outstation Travel",
    "WhyChoosedescription": "Our bus rental services in Pimpri Chinchwad are suitable for both local city travel and outstation destinations like Lonavala, Shirdi, Goa, Mahabaleshwar, and more. Whether you need transport for a wedding, religious trip, or company outing, we provide vehicles that are spacious, clean, and reliable for journeys of all lengths."
  },
  {
    "WhyChooseheading": "Multiple Seating Options to Fit Your Group Size",
    "WhyChoosedescription": "Choose from a variety of seating capacities including 17, 20, 32, 35, 40, 45, and 50-seater buses to match your group’s size and comfort needs. Our buses are equipped with comfortable seating, air conditioning (or non-AC on request), ample legroom, and space for luggage, ensuring an enjoyable experience for every passenger."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Route Expertise",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pimpri Chinchwad area and major routes across Maharashtra. They ensure punctual pickup and drop-offs, safe driving practices, and smooth coordination during the trip—making your journey worry-free whether it’s within the city or beyond."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Costs",
    "WhyChoosedescription": "Amruta Travels offers cost-effective pricing for Bus Hire in Pimpri Chinchwad with clear, upfront quotes and zero hidden charges. Whether you need a bus for a few hours or a full-day event, our flexible pricing structure allows you to plan your trip confidently within your budget."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained Buses for Every Occasion",
    "WhyChoosedescription": "All our buses are regularly serviced and thoroughly cleaned to maintain high hygiene and safety standards. With features like push-back seats, air ventilation, and tidy interiors, we guarantee a pleasant ride for your group on every occasion—be it a wedding, school picnic, or team outing."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop-off in Pimpri Chinchwad and Pune",
    "WhyChoosedescription": "We offer complete flexibility when it comes to your travel plan. Get picked up and dropped off at any location in Pimpri, Chinchwad, Nigdi, Akurdi, or nearby areas. Our goal is to make your travel as smooth and convenient as possible, right from your doorstep."
  },
  {
    "WhyChooseheading": "Quick Booking and Responsive Customer Support",
    "WhyChoosedescription": "Booking your bus in Pimpri Chinchwad is fast and easy with Amruta Travels. You can book online, by phone, or in-person at our office. Our support team is available to help you choose the right bus, create custom itineraries, and resolve any last-minute requests to ensure a smooth travel experience."
  }
]




















    }

const faqData = [
  {
    question: 'How can I hire a bus in Pimpri Chinchwad?',
    answer: 'You can easily hire a bus in Pimpri Chinchwad with Amruta Travels. Just call us, book online, or visit our office. We’ll assist you in choosing the right bus based on your group size and travel needs.',
  },
  {
    question: 'What types of buses are available for hire in Pimpri Chinchwad?',
    answer: 'We provide 32, 35, 40, 45, and 50-seater buses for hire in Pimpri Chinchwad. Our fleet includes standard, AC, non-AC, and luxury buses suitable for local and outstation travel.',
  },
  {
    question: 'Can I book a bus for local travel within Pimpri Chinchwad?',
    answer: 'Yes, our buses are available for local travel within Pimpri Chinchwad and surrounding areas. Ideal for weddings, events, school trips, corporate transport, and family functions.',
  },
  {
    question: 'Is outstation bus service available from Pimpri Chinchwad?',
    answer: 'Absolutely. We provide outstation bus services from Pimpri Chinchwad to popular destinations like Shirdi, Mumbai, Goa, Mahabaleshwar, and more. Our drivers are experienced and know the best routes.',
  },
  {
    question: 'Are the buses comfortable and safe?',
    answer: 'Yes, all our buses are well-maintained, regularly sanitized, and equipped with comfortable push-back seats, air conditioning, and ample luggage space to ensure a safe and pleasant journey.',
  },
  {
    question: 'How much does it cost to hire a bus in Pimpri Chinchwad?',
    answer: 'The cost depends on the type of bus, travel distance, and duration of your trip. Contact us with your requirements for a customized and transparent quote.',
  },
  {
    question: 'Can I request multiple pickup and drop-off points in Pimpri Chinchwad?',
    answer: 'Yes, we offer flexible pickup and drop services in and around Pimpri Chinchwad. Just provide your schedule, and we’ll plan the route accordingly.',
  },
  {
    question: 'Do you offer buses for corporate and industrial transport in Pimpri Chinchwad?',
    answer: 'Yes, we provide reliable and punctual bus services for corporate offices and industrial staff transport in Pimpri Chinchwad and MIDC areas.',
  },
  {
    question: 'Why choose Amruta Travels for bus hire in Pimpri Chinchwad?',
    answer: 'Amruta Travels offers dependable service, well-maintained buses, experienced drivers, and flexible booking options. We’re known for our professionalism, punctuality, and customer-first approach.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ramesh Kulkarni',
    role: 'Factory Manager, Pimpri MIDC',
    text: 'We hired a 45-seater bus from Amruta Travels for employee transport in Pimpri. The service was punctual and professional. The staff was happy with the comfort and cleanliness.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Aarti Gokhale',
    role: 'Wedding Planner, Chinchwad',
    text: 'Amruta Travels provided a 35-seater bus for a wedding event in Chinchwad. Everything went smoothly — the bus arrived on time, was clean, and the driver was courteous.',
    rating: 5,
  },
];























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Pimpri Chinchwad",
  "image": "https://bushireinpune.com/assets/images/bus-hire-in-pimpri-chinchwad.jpg",
  "description": "Affordable bus rental in Pimpri Chinchwad for weddings, school picnics, corporate trips, and outstation journeys. Choose from 14, 17, 25, 32, 35, 40, 45, and 50 seater buses, Urbania, and AC Tempo Travellers. Book nearby mini bus or large bus options with Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6585"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3299",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-hire-in-pimpri-chinchwad"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bus Hire in Pimpri Chinchwad | Wedding, Picnic & Outstation | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent buses in Pimpri Chinchwad for weddings, school trips, corporate travel & events. Options include 14–50 seater buses, AC Tempo Travellers, Urbania & Mini Buses. Reliable & affordable service near you." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/43.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireinpimprichichwad;